<script setup lang="ts">
import { setup, type Emits, type Props } from './baseMenu.setup';

const props = defineProps<Props>();
const emits = defineEmits<Emits>();
const { onClickTitle } = setup(props, emits);
</script>

<template>
  <h1
    :class="['base-menu-header__logo', { expand: props.isExpand }]"
    @click="onClickTitle"
  >
    {{ props?.productName }}
  </h1>
  <div
    class="base-menu-header__text"
    @click="onClickTitle"
  />
</template>

<style scoped lang="scss">
.base-menu-header {
  &__logo {
    background: url('@/common/assets/logo-exem-one.svg') no-repeat center center;
    background-size: 20px 20px;

    .view-mode-maxgauge & {
      background-image: url('@/common/assets/logo-maxgauge.svg');
    }

    .view-mode-intermax & {
      background-image: url('@/common/assets/logo-intermax.svg');
    }

    .base-menu:not(.expanded) & {
      display: block;
      flex-shrink: 0;
      width: var(--gnb-menu-item-content-width);
      min-width: var(--gnb-menu-item-content-width);
    }

    &.expand {
      flex-shrink: 0;
      width: var(--gnb-menu-item-content-width);
      min-width: var(--gnb-menu-item-content-width);
    }
  }

  &__text {
    flex: 1;
    height: 100%;
    cursor: pointer;
    background: url('@/common/assets/logo-exem-one-text-white.svg') no-repeat center left;

    .view-mode-maxgauge & {
      background-image: url('@/common/assets/logo-maxgauge-text-white.svg');
    }

    .view-mode-intermax & {
      background-image: url('@/common/assets/logo-intermax-text-white.svg');
    }

    // 확장되지 않은 축소형 GNB에서는 텍스트 로고 숨김 (아이콘만 노출)
    .base-menu:not(.expanded) & {
      display: none;
    }

    // 확장형일 때 로고 바로 우측에 붙이기
    .base-menu.expanded & {
      margin-left: 0;
    }
  }
}
</style>
